import {Action} from '@ngrx/store';
export const SET_TAX_FORMS_COUNTRIES_ACTION = '[TAX_FORMS] SET_TAX_FORMS_COUNTRIES_ACTION';
export class SetTaxFormsCountriesAction implements Action {
  readonly type = SET_TAX_FORMS_COUNTRIES_ACTION;

  constructor(public countries: any) {
  }
}
export type TranslationAction = SetTaxFormsCountriesAction;
